import { render } from "./Vaga.vue?vue&type=template&id=03658078&scoped=true"
import script from "./Vaga.vue?vue&type=script&lang=js"
export * from "./Vaga.vue?vue&type=script&lang=js"

import "./Vaga.vue?vue&type=style&index=0&id=03658078&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03658078"]])

export default __exports__